import { css } from '@emotion/react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ButtonComponent, ButtonStyle,
} from '~/_shared/baseComponents/buttons';
import { OverlayLoaderComponent } from '~/_shared/components/overlay/overlayLoader.component';
import {
  HOME_ROUTE, LOGIN_ROUTE, REGISTER_ROUTE,
} from '~/_shared/constants/routes';
import { useTranslation } from '~/_shared/utils/hooks';
import { AppErrorPageWrapperComponent } from '~/app/pages/errorPage/wrapper/appErrorPageWrapper.component';
import { AuthorizationPageWrapperComponent } from '~/authentication/pageWrapper/authenticationPageWrapper.component';

const textWrapperStyle = css({
  maxWidth: 680,
  flexDirection: 'column',
  display: 'flex',
  gap: 20,
});

export const SsoPageComponent = ({
  isLoading,
  error,
  showContinueWithEmail = false,
}: {
  isLoading: boolean;
  error?: string;
  // offers the email sign up when the SSO provider could not be used, e.g. the organization did not approve Maptive
  showContinueWithEmail?: boolean;
}) => {
  const [t] = useTranslation();
  const navigate = useNavigate();

  const onBackToLogin = useCallback(() => {
    navigate(LOGIN_ROUTE, { state: { from: HOME_ROUTE } });
  }, [navigate]);

  const handleContinueWithEmail = useCallback(() => {
    navigate(REGISTER_ROUTE);
  }, [navigate]);

  if (error) {
    return (
      <AppErrorPageWrapperComponent>
        <div css={textWrapperStyle}>
          {error}
          {showContinueWithEmail && (
            <ButtonComponent
              text={t('Continue with Email')}
              onClick={handleContinueWithEmail}
            />
          )}
          <ButtonComponent
            buttonStyle={showContinueWithEmail ? ButtonStyle.Secondary : undefined}
            text={t('Back to Login')}
            onClick={onBackToLogin}
          />
        </div>
      </AppErrorPageWrapperComponent>
    );
  }

  return (
    <AuthorizationPageWrapperComponent>
      {isLoading && (
        <OverlayLoaderComponent loaderSize={70} />
      )}
    </AuthorizationPageWrapperComponent>
  );
};
